import { dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { visitTranslationKeys } from '../../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../../visit/visit.draft';
import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToSpecialistFormController } from './ReferralToSpecialistForm/ReferralToSpecialistForm.types';

type ReferralToSpecialistRouteLeavingGuardProps = {
   readonly visitId: number;
   readonly formState: ReferralToSpecialistFormController['formState'];
   readonly handleSubmitDraft: ReferralToSpecialistFormController['handleSubmitDraft'];
   readonly electronic: boolean;
};

export const ReferralToSpecialistRouteLeavingGuard = (
   props: ReferralToSpecialistRouteLeavingGuardProps
): JSX.Element => {
   const { executeAsync: saveReferralToSpecialistDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });
   return (
      <RouteLeavingGuard
         testId={'referralToSpecialist'}
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (formValues) =>
            saveReferralToSpecialistDraft({
               token: getReferralDraftToken(
                  props.electronic ? 'electronicReferralToSpecialist' : 'referralToSpecialist',
                  props.visitId
               ),
               tags: props.electronic
                  ? undefined
                  : [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
               contents: formValues,
            })
         )}
         successMessage={referralTranslationKeys.referralDraftSaved}
      />
   );
};
